import React from "react";
import classnames from "classnames";
import { Field } from "react-final-form";
import { Tooltip } from "antd";
import "./style.scss";
import ValidationError from "./ValidationError";
import SubmitError from "./SubmitError";

class FieldSet extends React.Component {
  render() {
    const { props } = this;

    return (
      <Field name={props.name} validate={props.validate} parse={props.parse}>
        {({ input, meta }) => {
          return (
            <div className={classnames("ant-input-container", props.className)}>
              <div className="d-flex flex-row">
                <label>{props.label}</label>
                {this.props.tooltip && (
                  <Tooltip placement="top" title={this.props.tooltip}>
                    <i className="icon icon-help px-2" />
                  </Tooltip>
                )}
              </div>
              <span
                className={classnames({
                  "ant-input-container__error":
                    (meta.error && meta.dirty) ||
                    (meta.submitFailed && !meta.valid) ||
                    (meta.submitError && !meta.dirtySinceLastSubmit),
                  "ant-input-container__valid": meta.visited && meta.valid
                })}
              >
                <input
                  {...input}
                  className={classnames(
                    {
                      __error:
                        (meta.error && meta.dirty) ||
                        (meta.submitFailed && !meta.valid) ||
                        (meta.submitError && !meta.dirtySinceLastSubmit),
                      __valid: meta.visited && meta.valid
                    },
                    "ant-input"
                  )}
                  placeholder={props.placeholder}
                  size={props.width}
                  disabled={props.disabled}
                  readOnly={props.readOnly}
                  onBlur={this.props.onChange}
                  onChange={ev => {
                    input.onChange(ev);
                    this.props.onPartialChange &&
                      this.props.onPartialChange(ev);
                  }}
                  type={this.props.type}
                  style={this.props.style}
                />
              </span>
              <SubmitError name={props.name} />
              <ValidationError meta={meta} />
            </div>
          );
        }}
      </Field>
    );
  }
}

export default FieldSet;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/FieldSet.js